module.exports = __webpack_public_path__ + "img/rank-3.b0ba0af7.png";